import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/app/components/StudentHeroCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/app/components/TodayLessonQueue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/components/AppLayout.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f36ce163911b0014ad0543/ilmhub/src/components/ui/AppIcon.tsx");
